import { render, staticRenderFns } from "./WelcomingPage.vue?vue&type=template&id=4b431b36&scoped=true&lang=pug"
import script from "./WelcomingPage.vue?vue&type=script&lang=js"
export * from "./WelcomingPage.vue?vue&type=script&lang=js"
import style0 from "./WelcomingPage.vue?vue&type=style&index=0&id=4b431b36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b431b36",
  null
  
)

export default component.exports